export const ActionTypes = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  PRIORITIZE: "PRIORITIZE",
  RESET: "RESET",
};
